import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import template from './players.jade'
import {Player, Season} from '../../models'
import order from '../../services/positions'
import '../seasons'

@Component('sporty')
@Template(template)
@Attribute('season', Season)
export default class Players extends HTMLElement {
  attached() {
    this.load()
  }

  seasonChange() {
    this.load()
  }

  changeSeason({season}) {
    this.season = season || null
  }

  load() {
    var params = {$reload: true}
    if(this.season) params.season = this.season._id
    Player.load(params).then(data => {
      Object.assign(this, data)
      this.render()
    })
  }

  sortedTeams() {
    return (this.teams || []).sort((a, b) => a.name.localeCompare(b.name))
      .filter(a => !a.notAvailable)

  }

  sortedPlayers() {
    return (this.players || [])
      .filter(p => {
        return !p.position || order.includes(p.position)
      })
      .sort((a, b) => {
        var aTeam = a.team ? a.team.name : 'ZZZ'
        var bTeam = b.team ? b.team.name : 'ZZZ'
        return aTeam.localeCompare(bTeam) ||
          (a.shirt || Infinity) - (b.shirt || Infinity)
      })
  }

  flash(player) {
    player.$justSaved = true
    this.render()
    setTimeout(() => {
      player.$justSaved = false
      this.render()
    }, 500)
  }

  saveTeam(player, e) {
    if(player.team && player.team._id == e.target.value) return
    player.team = e.target.value
    return player.save().then(() => this.flash(player))
  }

  savePosition(player, e) {
    if(player.position == e.target.value) return
    player.position = e.target.value
    return player.save().then(() => this.flash(player))
  }

  savePrice(player, e) {
    if(!e.target.value || player.price == e.target.value) return
    player.price = +e.target.value
    return player.save().then(() => this.flash(player))
  }

  saveShirt(player, e) {
    if(
      !(e.target.value || e.target.value === 0) ||
      player.shirt == e.target.value
    ) return
    player.shirt = +e.target.value
    return player.save().then(() => this.flash(player))
  }

  get positions() {
    return order
  }
}
